import React, { FC } from "react";

import { ElCommunicationCampaignForm } from "../form";

export const ElCommunicationTab: FC = () => <ElCommunicationCampaignForm />;
